import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { BookmarkCheckedSvg } from './BookmarkChecked';

export const BookmarkCheckedIcon = createIcon('bookmarkChecked', BookmarkCheckedSvg);
/**
 * @deprecated используйте BookmarkCheckedIcon
 */
export const withBookmarkCheckedIcon = withIcon('bookmarkChecked', BookmarkCheckedSvg);
